import { CharacterSchema } from '@common/schemas/entities/character.schema';
import { z } from 'zod';

/** DTO shape = raw Firestore document, inferred from commons CharacterSchema */
export type CharacterDTO = z.infer<typeof CharacterSchema>;

/** Re-export ProcessedImage from common so feature consumers import from here */
export type { ProcessedImage } from '@common/schemas/entities/shared.schema';

/**
 * Character Form schema.
 * Extends Common schema with UI-only fields like pendingFiles.
 */
export const CharacterFormSchema = CharacterSchema.omit({ audit: true }).extend({
  id: z.string().optional(), // Optional for new entities
  pendingFiles: z.array(z.instanceof(File)).optional(),
}).passthrough();

export type CharacterFormValues = z.infer<typeof CharacterFormSchema>;
